import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  patientSurgery: {
    data: null,
    isLoading: true,
    message: null,
  },
};

export const patientSurgerySlice = createSlice({
  name: "patientSurgery",
  initialState,
  reducers: {
    onLoadPatientSurgery: (state, { payload }) => {
      state.patientSurgery.data = payload.patientSurgery;
      state.patientSurgery.isLoading = false;
      state.patientSurgery.message = {
        type: "success-patientSurgery",
        text: payload.message || "Quiz cargado correctamente",
      };
    },
    onFailedPatientSurgery: (state, { payload }) => {
      state.patientSurgery.data = null;
      state.patientSurgery.isLoading = false;
      state.patientSurgery.message = {
        type: "error-patientSurgery",
        text: payload.message || "Error al obtener el quiz",
      };
    },
    setQuizAnswered: (state, { payload }) => {
      state.patientSurgery.data = {
        ...state.patientSurgery.data,
        ...payload.patientSurgery,
      };
      state.patientSurgery.message = {
        type: "success-patientSurgery",
        text: payload.message || "Quiz respondido correctamente",
      };
    },
    updatePatientSurgery: (state, { payload }) => {
      state.patientSurgery.data = {
        ...state.patientSurgery.data,
        ...payload.patientSurgery,
      };
      state.patientSurgery.message = {
        type: "success",
        text: payload.message,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  onLoadPatientSurgery,
  onFailedPatientSurgery,
  setQuizAnswered,
  updatePatientSurgery,
} = patientSurgerySlice.actions;
